import { View, Modal, Text, StyleSheet, TouchableOpacity } from "react-native";
import React from "react";
import colors from "@constants/color";
import { normalize } from "@constants/metrics";

const CustomModal = ({
  heading,
  message,
  buttons = [],
  setShowModal,
  onPress,
  visible,
}) => {
  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={() => {
        if (setShowModal) {
          setShowModal();
        }
      }}
    >
      <View style={styles.mainView}>
        <View style={styles.innerView}>
          <Text
            style={{
              fontSize: normalize(18),
              fontFamily: "NotoSansDevanagari-SemiBold",
            }}
          >
            {heading}
          </Text>
          <Text style={styles.message}>{message}</Text>
          {buttons && (
            <View style={{ flexDirection: "row", justifyContent: "flex-end" }}>
              {buttons?.map((button, index) => {
                const isApiHit = button.hasOwnProperty("isApi")
                  ? button.isApi
                  : true;
                return (
                  <TouchableOpacity
                    onPress={() => {
                      if (isApiHit) {
                        onPress();
                      }
                      if (setShowModal) {
                        setShowModal();
                      }
                    }}
                  >
                    <Text
                      style={{
                        fontSize: normalize(14),
                        color: button.color ? button.color : colors.lightBlack,
                        fontFamily: "NotoSansDevanagari-Regular",
                        marginRight:
                          index + 1 != buttons.length ? normalize(40) : 0,
                      }}
                    >
                      {button.text}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>
          )}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  mainView: {
    backgroundColor: colors.modalBackground,
    width: "100%",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  innerView: {
    backgroundColor: colors.white,
    width: normalize(328),
    borderRadius: normalize(10),
    padding: normalize(24),
  },
  message: {
    fontSize: normalize(14),
    paddingTop: normalize(16),
    paddingBottom: normalize(24),
    color: colors.lightBlack,
    fontFamily: "NotoSansDevanagari-Regular",
  },
});

export default CustomModal;
